export const COOKIES_LOCAL_STORAGE = 'cookiesAccepted';
export const PRIVACY_LOCAL_STORAGE = 'privacyAccepted';
